import Vue from 'vue';

export default Vue.filter('no-content', (value: string) => {
  const data = String(value);
  return data || '-';
});
